/* No default placeholder here — an unset per-thread placeholder lets the composer fall
   back to its surface-mode prompts (composerInputPlaceholder → getRandomComposerPrompt). */
const sharedComposer = {};

export default sharedComposer;
